import { render, staticRenderFns } from "./VentasListaCarritoEntregadas.vue?vue&type=template&id=7b253980&"
import script from "./VentasListaCarritoEntregadas.vue?vue&type=script&lang=js&"
export * from "./VentasListaCarritoEntregadas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports